document.querySelectorAll("[data-gallery]").forEach((gallery) => {
  const params = new URLSearchParams(location.search);
  const initial = gallery.dataset.theme || params.get("theme") || "all";
  const buttons = [...gallery.querySelectorAll("[data-filter]")];
  function filter(value) {
    gallery.querySelectorAll("[data-art-theme]").forEach((card) => {
      card.hidden = value !== "all" && card.dataset.artTheme !== value;
    });
    buttons.forEach((button) =>
      button.setAttribute(
        "aria-pressed",
        String(button.dataset.filter === value),
      ),
    );
  }
  buttons.forEach((button) =>
    button.addEventListener("click", () => filter(button.dataset.filter)),
  );
  filter(
    buttons.some((button) => button.dataset.filter === initial)
      ? initial
      : "all",
  );
});

// Native details remains usable without JavaScript; close after a menu choice
// and restore focus to its toggle when dismissed with Escape.
document.querySelectorAll(".atelier-mobile-menu").forEach((menu) => {
  menu.querySelectorAll("nav a").forEach((link) => {
    link.addEventListener("click", () => { menu.open = false; });
  });
  menu.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && menu.open) {
      menu.open = false;
      menu.querySelector("summary").focus();
    }
  });
  document.addEventListener("click", (event) => {
    if (menu.open && !menu.contains(event.target)) menu.open = false;
  });
});

// The header can wrap at larger text sizes. Measure it instead of guessing an offset.
const siteHeader = document.querySelector("[data-site-header]");
if (siteHeader) {
  const measureHeader = () => document.documentElement.style.setProperty("--pw-header-height", Math.ceil(siteHeader.getBoundingClientRect().height) + "px");
  measureHeader();
  if (typeof ResizeObserver !== "undefined") new ResizeObserver(measureHeader).observe(siteHeader);
  else window.addEventListener("resize", measureHeader);
}
